import { render, staticRenderFns } from "./SourceFooter.vue?vue&type=template&id=078968a0&"
import script from "./SourceFooter.vue?vue&type=script&lang=js&"
export * from "./SourceFooter.vue?vue&type=script&lang=js&"
import style0 from "./SourceFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports